import { Box, CircularProgress } from '@mui/material';

import { useEffect, useState } from 'react';
import { Container } from './styles';

import { InfoCard } from '../../../components/InfoCard';
import { SectionMeetingCard } from '../components/SectionMeetingCard';

import {
  ListaReuniaoComMesAno,
  ReuniaoComMesAno,
} from '../../../services/requests';

interface MeetingsProps {
  reunioes: ListaReuniaoComMesAno[];
  reunioesCanceladas: ListaReuniaoComMesAno[] | undefined;
  loading: boolean;
  checked: boolean;
}

export const ReunioesFuturas = ({
  reunioes,
  loading,
  reunioesCanceladas,
  checked,
}: MeetingsProps) => {
  const [activesMeeting, setActivesMeeting] = useState<ReuniaoComMesAno[]>([]);
  useEffect(() => {
    if (reunioes) {
      const activesMeet = reunioes.flatMap(r =>
        r.meetings?.filter(m => m?.canceled_at === null),
      );

      setActivesMeeting(activesMeet);
    }
  }, [reunioes]);

  return (
    <Container>
      {loading ? (
        <Box paddingTop="200px">
          <CircularProgress />
        </Box>
      ) : checked ? (
        reunioesCanceladas && reunioesCanceladas?.length > 0 ? (
          reunioesCanceladas?.map(r => (
            <SectionMeetingCard
              key={r?.data}
              listagemReunioes={r}
              checked={checked}
            />
          ))
        ) : (
          <Box marginTop="250px">
            <InfoCard title="Nenhuma reunião cancelada foi encontrada" />
          </Box>
        )
      ) : activesMeeting && activesMeeting?.length > 0 ? (
        reunioes?.map(r => (
          <SectionMeetingCard
            key={r?.data}
            listagemReunioes={r}
            checked={checked}
          />
        ))
      ) : (
        // content
        <Box marginTop="250px">
          <InfoCard title="Nenhuma reunião encontrada" />
        </Box>
      )}
    </Container>
  );
};
